'use client'

import { useCart } from '@src/hooks/useCart'
import { useViewBuilderPage } from '@src/utils/analytics.util'

interface AnalyticsProps {
  pageType?: string
  analyticsData?: Record<string, any>
}

export const Analytics = ({ pageType, analyticsData }: AnalyticsProps) => {
  const { cart } = useCart()
  useViewBuilderPage(pageType, analyticsData, cart)

  return null
}
